import templateData from "./data-template";
export default {
  ...templateData
};
